import { InternalTransportFormValues, InternalTransportGate, InternalTransportToolVariant } from "./internalTransport.types";

export {
  calculateFreightWorkTkm,
  formatFreightWorkTkm,
  mapTransportationTypesToOptions,
  mergeRetiredTransportType
} from "../externalTransport/externalTransport.utils";

export const resolveInternalTransportSubmitName = (
  formData: InternalTransportFormValues,
  variant: InternalTransportToolVariant,
  originalName?: string
): string => {
  if (variant === "simulate" && originalName) {
    return originalName;
  }
  return formData.internalTransportName;
};

export const buildInternalTransportSubmitPayload = ({
  gate,
  gateId,
  internalTransportId,
  formData,
  defaultType,
  weightUnit,
  variant,
  originalName
}: {
  gate: InternalTransportGate;
  gateId: string;
  internalTransportId: string | null;
  formData: InternalTransportFormValues;
  defaultType: string;
  weightUnit: number;
  variant: InternalTransportToolVariant;
  originalName?: string;
}) => {
  const transportData: Record<string, unknown> = {
    internalTransportName: resolveInternalTransportSubmitName(formData, variant, originalName),
    transportationType: Number(defaultType),
    averageDistance: formData.averageDistance,
    weight: formData.weight ?? 0,
    weightUnit
  };

  if (variant === "simulate") {
    transportData.changeStatus = true;
  }

  if (gate === "farm") {
    return { farmGateId: gateId, internalTransportId, transportData };
  }

  return { processGateId: gateId, internalTransportId, transportData };
};

export const buildInternalTransportDeletePayload = ({
  gate,
  gateId,
  internalTransportId
}: {
  gate: InternalTransportGate;
  gateId: string | null | undefined;
  internalTransportId: string | null;
}) =>
  gate === "farm"
    ? { farmGateId: gateId, internalTransportId }
    : { processGateId: gateId, internalTransportId };
